import * as React from "react";
import Icon from "~/components/icons/icon";
import classNames from "classnames";

type TSearchIconVisibility = "mobile" | "desktop";

export interface INavigationSearchProps {
    searchPageUrl: string;
    navigationSearchLabel: string;
    visibility?: TSearchIconVisibility;
}

const NavigationSearch: React.SFC<INavigationSearchProps> = ({
    navigationSearchLabel,
    visibility
}: INavigationSearchProps) => {
    const baseClass = "navigation-search";
    return (
        <div
            className={classNames(baseClass, {
                [`${baseClass}--${visibility}`]: !!visibility
            })}
        >
            <button
                className="navigation-search__link"
                role="button"
                title={navigationSearchLabel}
                tabIndex={0}
                onClick={event => window.toggeNavigationSearch(event)}
                style={{ cursor: "pointer", backgroundColor: "transparent", border: "none" }}
            >
                <Icon iconId="32_search" />
            </button>
        </div>
    );
};

export default NavigationSearch;
